import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import QualityService from "../QualityService/QualityService";

const About = () => {
  return (
    <>
      <Breadcrumbs title="Rreth nesh" />
      <QualityService />
    </>
  );
};

export default About;
